<template>
  <div class="chart-skeleton-wrapper">
    <div v-if="isLoading" class="chart-skeleton">
      <div class="skeleton-circle-container">
        <div class="skeleton-circle">
          <div class="skeleton-circle-inner"></div>
        </div>
      </div>
      <div class="skeleton-legend flex flex-row">
        <div v-for="i in 4" :key="i" class="skeleton-legend-item">
          <div class="skeleton-legend-color"></div>
          <div class="skeleton-legend-text"></div>
        </div>
      </div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-skeleton-wrapper {
  position: relative;
  width: 100%;
  height: 300px;
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.chart-skeleton {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.skeleton-circle-container {
  width: 300px;
  height: 300px;
  position: relative;
}

.skeleton-circle {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 50%;
  animation: shimmer 1.4s infinite;

  &-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 50px;
    border-radius: 6px;
    background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
    animation: shimmer 1.4s infinite;
  }
}

.skeleton-legend {
  display: flex;
  flex-direction: column;
  margin-top: 40px;
}

.skeleton-legend-item {
  display: flex;
  align-items: center;
  margin: 0 15px 10px;
}

.skeleton-legend-color {
  width: 20px;
  height: 20px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  margin-right: 10px;
  animation: shimmer 1.4s infinite;
}

.skeleton-legend-text {
  width: 100px;
  height: 20px;
  background: linear-gradient(90deg, #F1EFEF -24.18%, #F9F8F8 50.26%, #E7E5E5 114.84%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.4s infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
